import { FC } from "react";

import dynamic from "next/dynamic";

import { UserConsentProps } from "./types";

// Disabled SSR to avoid memory leak caused by makeStyles
export const UserConsent = dynamic(() => import("./UserConsentSsr").then((mod) => mod.UserConsentSsr), {
  ssr: false,
}) as FC<UserConsentProps>;
